var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1161 14.6948H22.7944V13.3117C22.7944 12.9962 22.5647 12.7402 22.2816 12.7402H17.7183C17.4352 12.7402 17.2055 12.9962 17.2055 13.3117V14.6948H14.8838C14.6007 14.6948 14.371 14.9508 14.371 15.2663C14.371 15.5817 14.6007 15.8377 14.8838 15.8377H25.1161C25.3992 15.8377 25.6289 15.5817 25.6289 15.2663C25.6289 14.9508 25.3992 14.6948 25.1161 14.6948ZM23.4648 17.0468C23.4648 16.7313 23.6945 16.4754 23.9776 16.4754C24.2607 16.4754 24.4904 16.7306 24.4904 17.0468V25.6963C24.4904 26.5587 23.8614 27.2603 23.0882 27.2603H16.913C16.1391 27.2603 15.5094 26.5579 15.5094 25.6963V17.0468C15.5094 16.7313 15.7391 16.4754 16.0222 16.4754C16.3053 16.4754 16.535 16.7313 16.535 17.0468L16.5344 25.6963C16.5344 25.9284 16.7039 26.1174 16.9123 26.1174H23.0882C23.2958 26.1174 23.4648 25.9285 23.4648 25.6963V17.0468ZM19.3443 24.2083V17.0468C19.3443 16.7313 19.1146 16.4754 18.8315 16.4754C18.5483 16.4754 18.3186 16.7313 18.3186 17.0468V24.2083C18.3186 24.5238 18.5483 24.7797 18.8315 24.7797C19.1146 24.7797 19.3443 24.5245 19.3443 24.2083ZM21.6814 24.2083V17.0468C21.6814 16.7313 21.4517 16.4754 21.1685 16.4754C20.8854 16.4754 20.6557 16.7313 20.6557 17.0468V24.2083C20.6557 24.5238 20.8854 24.7797 21.1685 24.7797C21.4517 24.7797 21.6814 24.5245 21.6814 24.2083ZM18.2311 14.6948H21.7687V13.8831H18.2311V14.6948Z",
    fill: "#4C4C4C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 1.5,
    stroke: "#C6C2C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a1514c3a41fff7cb18633a0b250b3b3f.svg";
export { ForwardRef as ReactComponent };